<template>
    <div class="header-wrapper h-60px backdrop-blur-sm w-full flex-center text-#000 fixed left-0 top-0 z-99 bg-transparent">
        <span class="text-23px font-600 cursor-pointer" @click="router.push('/home')">{{ title }}</span>
        <div class="flex gap-40px ml-135px">
            <div
                v-for="(menu, index) in state.menuList"
                :key="index"
                :index="index"
                class="menu-item cursor-pointer"
                :class="{ active: menu.active }"
            >
                <span @click="handleJumpPage(menu)">{{ menu.name }}</span>
            </div>
        </div>
        <div class="ml-190">
            <el-button link v-if="!userName">
                <Login :is-change-style="changeButStyle" />
            </el-button>
            <Avatar v-else class="min-h-0" :class="{ 'home-border': route.path === '/home' }" />
        </div>
    </div>
</template>
<script setup lang="ts">
import throttle from 'lodash/throttle';
import Login from './Login.vue';
import Avatar from './Avatar.vue';

const { userName } = useStore('user');
const { title } = useStore('common');
const router = useRouter();
const route = useRoute();
const lastScrollTop = ref(0);
// 判断是否需要变更样式
const changeButStyle = ref(false);
const state = reactive<any>({
    menuList: [
        {
            name: 'FlagGems',
            path: '/flag-gems',
        },
        {
            name: 'FlagScale',
            path: '/flag-scale',
        },
        {
            name: 'FlagTree',
            path: '/flag-tree',
        },
        {
            name: 'FlagCX',
            path: '/flag-cx',
        },
        {
            name: 'FlagRelease',
            path: '/flag-release',
        },
        // {
        //     name: 'FlagPerf',
        //     path: '/flag-perf',
        // },
        {
            name: '学习中心',
            path: '/learn-center',
        },
        {
            name: '问题交流',
            path: '/community',
        },
    ],
});

watch(
    () => route.path,
    () => {
        nextTick(() => {
            // 特殊处理：issue-form 和 issue-detail 也属于问题交流页面
            const isIssueRelatedPage = route.path?.indexOf('/issue-form') >= 0 || route.path?.indexOf('/issue-detail') >= 0;

            let curMenuIdx = state.menuList.findIndex((item: any) => {
                // 如果是问题相关页面，匹配问题交流菜单
                if (isIssueRelatedPage && item.path === '/community') {
                    return true;
                }
                // 其他情况按原逻辑匹配
                return route.path.indexOf(item.path) >= 0;
            });
            if (curMenuIdx >= 0) {
                state.menuList[curMenuIdx].active = true;
            } else {
                state.menuList.forEach((item: any) => {
                    item.active = false;
                });
            }
            if (route.path?.indexOf('/home') >= 0) {
                document.querySelector('.header-wrapper')?.classList.add('theme-white');
                document.querySelector('.header-wrapper')?.classList.remove('white-bg');
                changeButStyle.value = true;
            } else {
                document.querySelector('.header-wrapper')?.classList.remove('theme-white');
                changeButStyle.value = false;
            }
            // 处理 home 页面的特殊滚动逻辑
            if (route.path?.indexOf('/home') >= 0) {
                window.addEventListener('scroll', handleScroll);
            } else {
                window.removeEventListener('scroll', handleScroll);
            }
            // 初始化通用滚动监听状态
            handleGeneralScroll();
        });
    },
    { immediate: true }
);

function handleJumpPage(menu: any) {
    state.menuList.forEach((item: any) => {
        item.active = false;
    });
    menu.active = true;
    router.push(menu.path);
}

const handleScroll = throttle(function () {
    const scrollTop = window.scrollY || document.documentElement.scrollTop || 0;
    // 检测滚动方向
    if (scrollTop > lastScrollTop.value) {
    } else {
    }
    let featEle = document.querySelector('#home-feat-box');
    let featRect = featEle?.getBoundingClientRect();
    if ((featRect?.top ?? 0) <= 50) {
        document.querySelector('.header-wrapper')?.classList.remove('theme-white');
        document.querySelector('.header-wrapper')?.classList.add('white-bg');
        changeButStyle.value = false;
    } else {
        document.querySelector('.header-wrapper')?.classList.add('theme-white');
        document.querySelector('.header-wrapper')?.classList.remove('white-bg');
        changeButStyle.value = true;
    }
    lastScrollTop.value = scrollTop <= 0 ? 0 : scrollTop;
}, 200);

// 通用滚动监听：当滚动超过30px时设置白色背景（排除 home 路由）
const handleGeneralScroll = throttle(function () {
    // 排除 home 路由页面
    if (route.path?.indexOf('/home') >= 0) {
        return;
    }
    const scrollTop = window.scrollY || document.documentElement.scrollTop || 0;
    const headerWrapper = document.querySelector('.header-wrapper');
    if (headerWrapper) {
        if (scrollTop > 30) {
            headerWrapper.classList.add('has-bg');
        } else {
            headerWrapper.classList.remove('has-bg');
        }
    }
}, 100);

onMounted(() => {
    // 只在 home 页面添加 handleScroll 监听
    if (route.path?.indexOf('/home') >= 0) {
        window.addEventListener('scroll', handleScroll);
    }
    // 所有页面都添加通用滚动监听
    window.addEventListener('scroll', handleGeneralScroll);
    // 初始化时检查一次
    handleGeneralScroll();
});

onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll);
    window.removeEventListener('scroll', handleGeneralScroll);
});
</script>
<style scoped lang="scss">
.header-wrapper {
    transition: background-color 0.3s ease;
    &.has-bg {
        background-color: #fff !important;
        box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.11);
    }
    &.white-bg {
        background-color: #fff;
        box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.11);
    }

    &.theme-white {
        color: #fff;
        background-color: transparent;
        .home-border {
            color: #fff;
        }
    }
    .menu-item {
        position: relative;
        font-size: 14px;
        &::before {
            content: '';
            display: block;
            position: absolute;
            left: 0;
            bottom: 0;
            width: 0;
            height: 2px;
            border-radius: 1px;
            background-color: #3967e9;
            transition: all 0.3s ease;
            transform-origin: center;
        }
        &.active {
            &::before {
                width: 100%;
            }
        }
    }
}
</style>
